"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushNotificationPublisher = void 0;
var Publisher_1 = require("../Publisher");
var PushNotificationTopic_1 = require("../topics/PushNotificationTopic");
var PushNotificationPublisher = exports.PushNotificationPublisher = /** @class */ (function (_super) {
    __extends(PushNotificationPublisher, _super);
    function PushNotificationPublisher(client) {
        return _super.call(this, client, PushNotificationPublisher.topic) || this;
    }
    PushNotificationPublisher.topic = new PushNotificationTopic_1.PushNotificationTopic();
    return PushNotificationPublisher;
}(Publisher_1.Publisher));
//# sourceMappingURL=PushNotificationPublisher.js.map